import { render, staticRenderFns } from "./DepositInputModal.vue?vue&type=template&id=62c54d12&"
import script from "./DepositInputModal.vue?vue&type=script&lang=ts&"
export * from "./DepositInputModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports